import React from "react";
import Select from "react-select";
import { withStyles } from "@material-ui/core";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import {observer, inject} from "mobx-react";

const style = theme => ({
    Dropdown:{
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor
    },
    reactSelect:{
        display: "inline-block",
        fontWeight: "normal",
        '& .select__control':{
            minWidth: 130,
            maxWidth: 130,
            backgroundColor: "transparent",
            minHeight: 24,
            maxHeight: 24,
            boxSizing:"border-box",
            borderRadius: 2,
            border: `1px solid ${theme.iconColor}`,
            fontSize: 12,
            '&:hover,&.select__control--is-focused':{
                boxShadow: "none",
                borderRadius: 2,
                border: `1px solid ${theme.iconColor}`,
            },
            '& .select__value-container':{
                height: 24,
                color: theme.TextColor
            },
            '& .select__single-value':{
                color: "inherit"
            },
            '& .select__indicators':{
                height: 24,
                '& .select__indicator':{
                    padding: 5,
                    height: 24,
                },
                '& .select__indicator-separator':{
                    height: 24,
                    margin: 0,
                    display: "none"
                }
            }
        },
        '& .select__menu':{
            margin: 0,
            maxHeight: 140,
            borderRadius: 2,
            border: `1px solid ${theme.iconColor}`,
            '& .select__menu-list': {
                maxHeight: 139,
                borderRadius: 2,
                fontSize:12,
                backgroundColor: theme.ModalBGColor,
                color: theme.TextColor,
            },
            '& .select__option--is-focused':{
                backgroundColor: theme.HighlightColor
            },
            '& .select__option--is-selected':{
                backgroundColor: theme.HeaderSelectedText
            }
        }
    },

    iconStyle:{
        color: theme.iconColor,
        cursor: "pointer"
    }
})


@inject("CommonStore")
@observer

class TerminalDropdownComponent extends React.Component{
    constructor(props){
        super(props);
        this.options = [];
        this.state = {
            value: null,
            options:[]
        }
    }

    componentDidMount(){
        this.updateSelectOptions();
    }

    componentDidUpdate(prevProps){
        // if(prevProps.column.colDef.field != this.props.column.colDef.field){
        //     this.updateSelectOptions();
        // }
    }

    updateSelectOptions = () => {
        const options = this.props.CommonStore.terminalList.slice();

        this.setState({
            options,
            value: options.find(option => option.value === this.props.selectedTerminalID) || null
        })
    }


    handleChange = (value) => {
        if(value){
            this.setState({
                value:{
                    label: value.label,
                    value: value.value,
                }
            },this.onChange);
        } else {
            this.setState({
                value
            }, this.onChange)
        }
    }

    onChange = () => {
        if(this.props.onChange){
            this.props.onChange(this.state.value);
        }
    }


    filterOption = (option, filterValue) => {
        return option.label.includes(filterValue);
    }


    render(){
        const { classes } = this.props;
        return (
            <Select
                value={this.state.value}
                onChange={this.handleChange}
                options={ this.state.options}
                classNamePrefix={"select"}
                className={classes.reactSelect}
                menuPlacement="auto"
                menuPosition="fixed"
                filterOption={this.filterOption}
                closeMenuOnSelect
                components = {{
                    DropdownIndicator: props => <ArrowDropDown {...props.innerProps} className={classes.iconStyle} />,
                }}
            />
        )
    }
}

export default withStyles(style)(TerminalDropdownComponent);